import React from "react";
import ContentLoader from "react-content-loader";

const DetailViewInfoSkeleton = (props) => (
   <div className="conversations-body pt-2 px-3">
    <div className="tab-content mt-2">
        <div className="tab-pane fade active show ">
            <div className="card">
                <div className="card-header p-2 position-relative d-flex align-items-center justify-content-between">
                    <div className="card-title">
                        <h6 className="content_title mb-0"> {props.label}  Information </h6> </div>
                </div>
                <div className="card-body">

                    <div className="row">
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={100} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>
                        <div className="col-md-4 col-12">
                            <ContentLoader speed={1} viewBox="0 0 100% 80" width="100%" height={80} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" {...props}>
                                <rect x="0" y="10" rx="3" ry="3" width="180" height="12" />
                                <rect x="0" y="30" rx="3" ry="3" width="220" height="16" />
                            </ContentLoader>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
    
  
);

export default DetailViewInfoSkeleton;
